<div class="top-message {{messageService.messageType}}" *ngIf="messageService.messageVisible">
    <span class="icon"></span>
    <p>
      {{messageService.message}}
    </p>
  
    <a class="close-message" (click)="messageService.closeMessage()"></a>
  </div>
  
  <div class="loading-message" *ngIf="messageService.loadingVisible">
    <img src="/assets/images/loader.gif" />
  </div>